// import React, { useState, useRef } from "react";
// import LockImage from "../../assests/tiny-people-carrying-key.png";
// import SuccessImage from "../../assests/PasswordSuccess.png";
// import style from "./EmailVerification.module.css";
// import { useLocation, useNavigate } from "react-router-dom";
// import { baseurl } from "../Url";
import { ROLE_003, ROLE_004 } from "../../constants/roles";

// const EmailVerification = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const email = location.state?.Email;
//   const [contentShow, setContentShow] = useState("otpSection");
//   const [otp, setOTP] = useState(Array(5).fill(""));
//   const inputRefs = useRef([]);

//   const handleChange = (e, i) => {
//     const value = e.target.value;

//     if (/^[0-9]$/.test(value) || value === "") {
//       setOTP((prev) => {
//         const newOtp = [...prev];
//         newOtp[i] = value;
//         return newOtp;
//       });

//       // Move focus to the next input if a value is entered
//       if (value && i < inputRefs.current.length - 1) {
//         inputRefs.current[i + 1].focus();
//       }
//     }
//   };

//   const handleFocus = (i) => {
//     // Optionally select the text when an input gains focus
//     if (inputRefs.current[i]) {
//       inputRefs.current[i].select();
//     }
//   };

//   async function userValidation() {
//     const body = {
//       email: email,
//       otp: otp.join(""),
//     };

//     await fetch(`${baseurl}/otp/validate/user`, {
//       method: "POST",
//       body: JSON.stringify(body),
//       headers: {
//         "Content-Type": "application/json",
//       },
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         console.log(data);
//         if (data.status === true) {
//           setContentShow("successSection")
//           setOTP(Array(5).fill(""));
//           localStorage.setItem("access-token", JSON.stringify(data.data[0]?.access_token));
//           localStorage.setItem("ClubID", data.data[0]?.club_id);
//           localStorage.setItem("ORGID", data.data[0]?.org_id);
//           localStorage.setItem("USERID", data.data[0]?.user_id);
//           localStorage.setItem("mentor", data.data[0]?.is_mentor);
//           localStorage.setItem("username", data.data[0]?.Username);
//           setTimeout(() => {
//             navigate("/")
//           }, 2000);
//         } else if (data.status === "error" || data.status === "failed" || data.status === false) {
//           alert(data.description || "Verification failed");
//         }
//       });
//   }
//   return (
//     <div className={style.container}>
//       <div className={style.contentLeft}>
//         <div className={style.resetCard}>
//           {contentShow === "otpSection" ? (
//             <div className={style.cardContent}>
//               <div className={style.cardHeader}>
//                 <h4>Verification</h4>
//                 <span>Enter the verification code below.</span>
//               </div>
//               <div className={style.cardBody}>
//                 <div className={style.otpSection}>
//                   {otp.map((_, i) => (
//                     <div key={i} className={style.otpInput}>
//                       <input
//                         ref={(el) => (inputRefs.current[i] = el)}
//                         maxLength={1}
//                         required
//                         value={otp[i]}
//                         onChange={(e) => handleChange(e, i)}
//                         onFocus={() => handleFocus(i)}
//                       />
//                     </div>
//                   ))}
//                 </div>
//                 <div className={style.cardButton}>
//                   <button
//                     onClick={() => {
//                       userValidation();
//                     }}
//                   >
//                     Send
//                   </button>
//                 </div>
//                 <div className={style.cardBottomText}>
//                   <p>
//                     Didn’t receive code? <span>Resend</span>
//                   </p>
//                 </div>
//               </div>
//             </div>
//           ) : contentShow === "successSection" ? (
//             <div className={style.successContent}>
//               <div className={style.successImage}>
//                 <img src={SuccessImage} alt="Success" />
//               </div>
//               <div className={style.successText}>
//                 <p>Email verified successfully.</p>
//               </div>
//             </div>
//           ) : (
//             ""
//           )}
//         </div>
//       </div>
//       <div className={style.contentRight}>
//         <div className={style.rightImage}>
//           <img src={LockImage} alt="Password reset" />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default EmailVerification;



import React, { useState, useRef } from "react";
import VerificationImage from "../../assests/verification.png";
import SuccessImage from "../../assests/PasswordSuccess.png";
import style from "./EmailVerification.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { baseurl, getPostAuthRedirectPath } from "../Url";

const EmailVerification = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { Email, Username, Name, mode, isMentor, role } = location.state || {};

  const [contentShow, setContentShow] = useState("otpSection");
  const [otp, setOTP] = useState(Array(6).fill(""));
  const inputRefs = useRef([]);

  const handleChange = (e, i) => {
    const value = e.target.value;

    if (/^[0-9]$/.test(value) || value === "") {
      setOTP((prev) => {
        const newOtp = [...prev];
        newOtp[i] = value;
        return newOtp;
      });

      if (value && i < inputRefs.current.length - 1) {
        inputRefs.current[i + 1].focus();
      }
    }
  };

  const handleFocus = (i) => {
    inputRefs.current[i]?.select();
  };

  const handlePaste = (e) => {
    const pasteData = e.clipboardData.getData("text").trim().slice(0, 6);
    if (/^\d+$/.test(pasteData)) {
      const newOtp = [...otp];
      const pasteDigits = pasteData.split("");

      // Fill from the first box for now to keep it simple and consistent with typical OTP behavior
      pasteDigits.forEach((char, index) => {
        if (index < otp.length) {
          newOtp[index] = char;
        }
      });

      setOTP(newOtp);
      // Focus the last filled input or the first empty one
      const lastIndex = Math.min(pasteDigits.length, otp.length - 1);
      inputRefs.current[lastIndex]?.focus();
    }
    e.preventDefault();
  };

  async function handleResend() {
    try {
      const endpoint = mode === "login" ? "/account/send-login-otp" : "/account/send-signup-otp";
      const body = mode === "login" ? { Email: Email } : { Username: Email, Email: Email };

      const res = await fetch(`${baseurl}${endpoint}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      const data = await res.json();
      if (data.status === "success" || data.status === true) {
        alert("OTP Resent successfully!");
      } else {
        alert(data.message || "Failed to resend OTP");
      }
    } catch (err) {
      console.error(err);
      alert("Error resending OTP");
    }
  }

  // 🔐 STEP 1: VERIFY OTP
  async function verifyOtp() {
    if (mode === "login") {
      // LOGIN FLOW
      const body = { email: Email, otp: otp.join(""), is_mentor_login: isMentor };
      try {
        const res = await fetch(`${baseurl}/otp/validate/user`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        });
        const data = await res.json();

        if (data.status === true) {
          // Store tokens
          const userData = data.data[0] || data.data || {};
          // Handle loose structure if needed, but based on previous Login.jsx:
          // It appeared to be data.data[0] in one snippet or data.data in another.
          // Let's assume the previous Login.jsx logic was correct, which I saw earlier:
          // const userData = data.data[0] || data.data;

          if (userData) {
            localStorage.setItem("access-token", JSON.stringify(userData.access_token));
            localStorage.setItem("ClubID", userData.club_id);
            localStorage.setItem("ORGID", userData.org_id);
            localStorage.setItem("USERID", userData.user_id);
            localStorage.setItem("mentor", userData.is_mentor);
            localStorage.setItem("roleId", userData.is_mentor ? ROLE_003 : ROLE_004);
            localStorage.setItem("role", isMentor ? "mentor" : "intern");
            localStorage.setItem("username", userData.Username);
          }

          setContentShow("successSection");
          const redirectPath = getPostAuthRedirectPath(userData.user_id);
          setTimeout(() => navigate(redirectPath), 1500);
        } else {
          alert(data.description || "Invalid OTP");
        }
      } catch (err) {
        console.error(err);
        alert("Error verifying OTP");
      }

    } else {
      // SIGNUP FLOW
      const body = {
        Email: Email,
        otp: otp.join(""),
      };

      const res = await fetch(`${baseurl}/account/verify-signup-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      const data = await res.json();

      if (data.status === "success") {
        await finalSignup();
      } else {
        alert(data.message || "Invalid OTP");
      }
    }
  }

  // 🧑‍💻 STEP 2: FINAL SIGNUP
  async function finalSignup() {
    const referralCode =
      (typeof window !== "undefined" && window.localStorage.getItem("duno_referral_code")) ||
      (typeof window !== "undefined" && window.sessionStorage.getItem("duno_referral_code"));
    const referralAssetCategory =
      (typeof window !== "undefined" && window.localStorage.getItem("duno_referral_asset_category")) ||
      (typeof window !== "undefined" && window.sessionStorage.getItem("duno_referral_asset_category"));
    const referralAssetId =
      (typeof window !== "undefined" && window.localStorage.getItem("duno_referral_asset_id")) ||
      (typeof window !== "undefined" && window.sessionStorage.getItem("duno_referral_asset_id"));
    const body = {
      Username: Email,
      Email: Email,
      Name: Name,
      role: role,
    };
    if (referralCode) {
      body.referral_code = referralCode;
    }
    if (referralAssetCategory) {
      body.referral_asset_category = referralAssetCategory;
    }
    if (referralAssetId) {
      body.referral_asset_id = referralAssetId;
    }
    const res = await fetch(`${baseurl}/account/signup`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });

    const data = await res.json();

    if (data.status === "success") {
      // Store auth data so the dashboard keeps the user logged in
      const userData = data.data || {};
      if (userData.access_token) {
        localStorage.setItem("access-token", JSON.stringify(userData.access_token));
      }
      localStorage.setItem("ClubID", userData.club_id ? (Array.isArray(userData.club_id) ? userData.club_id[0] : userData.club_id) : "");
      localStorage.setItem("ORGID", userData.org_id || "");
      localStorage.setItem("USERID", userData.user_id || "");
      localStorage.setItem("mentor", userData.is_mentor || false);
      localStorage.setItem("roleId", userData.is_mentor ? ROLE_003 : ROLE_004);
      localStorage.setItem("role", userData.is_mentor ? "mentor" : "intern");
      localStorage.setItem("username", userData.Username || Email);

      setContentShow("successSection");

      const redirectPath = getPostAuthRedirectPath(userData.user_id || "");
      setTimeout(() => {
        navigate(redirectPath);
      }, 2000);
    } else {
      alert(data.message || "Signup failed");
    }
  }

  return (
    <div className={style.container}>
      <div className={style.contentLeft}>
        <div className={style.resetCard}>
          {contentShow === "otpSection" ? (
            <div className={style.cardContent}>
              <div className={style.cardHeader}>
                <h4>{mode === "login" ? "Login Verification" : "OTP Verification"}</h4>
                <span>Enter the verification code sent to {Email}</span>
              </div>

              <div className={style.cardBody}>
                <div className={style.otpSection}>
                  {otp.map((_, i) => (
                    <div key={i} className={style.otpInput}>
                      <input
                        ref={(el) => (inputRefs.current[i] = el)}
                        maxLength={1}
                        value={otp[i]}
                        onChange={(e) => handleChange(e, i)}
                        onFocus={() => handleFocus(i)}
                        onPaste={handlePaste}
                      />
                    </div>
                  ))}
                </div>

                <div className={style.cardButton}>
                  <button onClick={verifyOtp}>Verify</button>
                </div>

                <div className={style.cardBottomText}>
                  <p>
                    Didn’t receive code?{" "}
                    <span
                      onClick={handleResend}
                      className={style.resendBtn}
                    >
                      Resend
                    </span>
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div className={style.successContent}>
              <div className={style.successImage}>
                <img src={SuccessImage} alt="Success" />
              </div>
              <div className={style.successText}>
                <p>Email verified successfully 🎉</p>
                <p>Redirecting to Home</p>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className={style.contentRight}>
        <div className={style.rightImage}>
          <img src={VerificationImage} alt="Verification" />
        </div>
      </div>
    </div>
  );
};

export default EmailVerification;
